// TestWriting.js

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { saveQuizScore, updateStudyStreak } from '../utils/storage';
import BackButton from '../components/BackButton';
import './styles/TestWriting.css';

const TestWriting = () => {
    const location = useLocation();
  const { content, name, translation } = location.state || {};
  const lines = content.split('\n').filter((line) => line.trim().length > 0);
  const translatedLines = translation.split('\n').filter((line) => line.trim().length > 0);

  const [showOverview, setShowOverview] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState('');

  useEffect(() => {
    const loadUserLanguage = async () => {
      setSelectedLanguage('en');
    };

    loadUserLanguage();
  }, []);

  const speakNow = (line) => {
    const synth = window.speechSynthesis;
    synth.cancel();
    const utterance = new SpeechSynthesisUtterance(line);
    utterance.lang = "fi-FI";
    synth.speak(utterance);
  };


  const [answers, setAnswers] = useState(new Array(lines.length).fill(''));
  const [results, setResults] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    const newResults = answers.map(
      (answer, index) => answer.trim().toLowerCase() === lines[index].trim().toLowerCase()
    );
    setResults(newResults);
    const correctCount = newResults.filter(r => r).length;
    saveQuizScore('Writing', correctCount, lines.length);
    updateStudyStreak();
  };

  const handleClear = () => {
    setAnswers(new Array(lines.length).fill(''));
    setResults([]);
    setSubmitted(false);
  };

  const handleAnswerChange = (text, index) => {
    const newAnswers = [...answers];
    newAnswers[index] = text;
    setAnswers(newAnswers);
  };

  const countCorrectAnswers = () => {
    return results.filter((result) => result).length;
  };

  const totalQuestions = lines.length;

  return (
      <div className="container">
        <BackButton label="Back" />
        {translatedLines.length === 0 ? (
          <div className="noQuestionsContainer">
            <p className="noQuestionsText">No questions available</p>
          </div>
        ) : (
          <div className="scrollContainer">
            <h1 className="title">{name}</h1>
            {translatedLines.map((question, index) => (
              <div key={index} className="questionContainer">
                <p className="writing-questionText">{`${index + 1}. ${translatedLines[index]}`}</p>
                <div className="answerContainer">
                  <input
                    className={`input ${results[index] !== undefined ? (results[index] ? 'correct' : 'incorrect') : ''}`}
                    value={answers[index]}
                    onChange={(e) => handleAnswerChange(e.target.value, index)}
                  />
                  {results[index] && (
                    <img
                      src={require('../assets/images/ok.png')}
                      alt="correct"
                      className="resultIcon"
                    />
                  )}
                  {results[index] === false && (
                    <img
                      src={require('../assets/images/refresh-dark.png')}
                      alt="refresh"
                      className="resultIcon"
                      onClick={() => {
                        handleSubmit();
                        setSubmitted(true);
                      }}
                    />
                  )}
                </div>
                {results[index] === false && (
                  <div className="correctAnswerContainer">
                    <div className="wrongResultText">{`Correct answer: ${lines[index]}`}
                    <img
                      src={require('../assets/images/voice-dark.png')}
                      alt="speak"
                      className="voiceIcon"
                      onClick={() => speakNow(lines[index])}
                    />
                    </div>
                    
                  </div>
                )}
                {results[index] && (
                  <div className="correctAnswerContainer">
                    <div className="resultText">{`Correct answer: ${lines[index]}`}
                    <img
                      src={require('../assets/images/voice-dark.png')}
                      alt="speak"
                      className="voiceIcon"
                      onClick={() => speakNow(lines[index])}
                    /></div>
                    
                  </div>
                )}
              </div>
            ))}
            {submitted && (
              <div className="bottomContainer">
                <p className="countText">{`Correct Answers: ${countCorrectAnswers()} / ${totalQuestions}`}</p>
              </div>
            )}
            <div className="buttonContainer">
              <button className="submitButton" onClick={() => {
                handleSubmit();
                setSubmitted(true);
              }}>
                Submit
              </button>
              <button className="clearButton" onClick={handleClear}>
                Clear
              </button>
            </div>
          </div>
        )}

      </div>
  );
};

export default TestWriting;
